import Vue from 'vue'
import VueRouter from 'vue-router'
import useJwt from '@/auth/jwt/useJwt'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import home from './routes/home'
import general from './routes/general'
import craft from './routes/craft'

Vue.use(VueRouter)
let dashboardz
const sso = process.env.VUE_APP_USING_SSO === 'true'
if (isUserLoggedIn()) {
  const queryParams = sso ? {
    params: {
      platform_id: process.env.VUE_APP_PLATFORM_ID,
    },
  } : {}
  useJwt.getPrivilegeUserPlatform(queryParams).then(response => {
    dashboardz = response.data.data.privilege_category[0].privilege_category[0].url
  })
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: () => ({ name: dashboardz || 'dashboard-sparing' }),
    },
    ...home,
    ...general,
    ...craft,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  const { host, protocol } = window.location
  const baseUrl = process.env.VUE_APP_USER_API
  const clientId = process.env.VUE_APP_CLIENT_ID
  const clientSecret = process.env.VUE_APP_CLIENT_SECRET
  const redirectUri = `${protocol}//${host}/callback-login`
  const responseType = 'code'
  const state = 'dashboard'
  // Special handling: if SSO is enabled and user tries to access login page without token
  if (sso && !isLoggedIn && to.name === 'auth-login') {
    const authorizeUrl = `${baseUrl}/internal/oauth/authorize?client_id=${clientId}&client_secret=${clientSecret}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&state=${state}`
    return window.location.replace(authorizeUrl)
  }
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn && !sso) return next({ name: 'auth-login' })

    if (!isLoggedIn && sso) {
      const authorizeUrl = `${baseUrl}/internal/oauth/authorize?client_id=${clientId}&client_secret=${clientSecret}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&state=${state}`
      return window.location.replace(authorizeUrl)
    }

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    localStorage.getItem('acessToken', localStorage.accessToken)
    return next(dashboardz || { name: 'dashboard-sparing' })
  }

  return next()
})

router.afterEach(() => {
  // Remove initial loading

})

export default router
